import OrderItemGroupService from '../../services/OrderItemGroupService';
import OrderItemService from '../../services/OrderItemService';
import OrderItemStatusService from '../../services/OrderItemStatusService';
import OrderService from '../../services/OrderService';
import orderUseCase from './orderUseCase';

const orderFactory = orderUseCase({
  OrderService: OrderService(),
  OrderItemGroupService: OrderItemGroupService(),
  OrderItemService: OrderItemService(),
  OrderItemStatusService: OrderItemStatusService(),
});

export default orderFactory;
